import {
    Comments,
} from './components';
import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import * as actions from "redux/actions/dashboardActions";
import MarketWinLow from 'components/MarketWinLow';
import FearGreedIndex from 'components/FearGreedIndex';
import 'assets/css/wall.css';

const Wall = (props) => {
    const [list, setList] = useState({});

    useEffect(() => {
        // props.loadList(props.user_id, props.token);
    }, list);

    return (
        <div className="wall-page">
            <div className="wall-row">
                    <Comments history={props.history} />
                <div className="wall-side">
                    <FearGreedIndex />
                    <MarketWinLow />
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
    };
}

const mapDispatchToProps = dispatch => ({
    // loadList: (user_id, token) =>
    //   dispatch(actions.loadListLatesroi({ user_id, token })), 
    // <StockCategory />
});
export default connect(mapStateToProps, mapDispatchToProps)(Wall);